export enum PricesTypes {
    NoBoard = 'NoBoard',
    BedAndBreakfast = 'BedAndBreakfast',
    HalfBoard = 'HalfBoard',
    FullBoard = 'FullBoard',
    Individual = 'Individual',
    LuggagePrice = 'luggage_price',
    BackPrice = 'back_price',
    PeoplePrice = 'people_price'
}